export const wangluoArticles = [
  {
    id: "wangluo-1",
    title: "流量黑产调查：一条点赞只要三分钱的地下产业链",
    summary: "点赞、转发、粉丝，几乎所有数据都能被“制造”。我们还原了这条灰色链条的运作方式。",
    categoryId: "wangluo",
    categoryName: "网络揭秘",
    publishedAt: "2026-10-12 14:00",
    source: "网络安全观察",
    tags: ["流量黑产", "数据造假", "平台生态"],
    heat: 8890,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stylized%20digital%20data%20stream%20and%20network%20nodes%20in%20deep%20slate%20blue%20with%20orange%20accent%20glows%2C%20minimal%20geometric%20illustration%2C%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=1200&height=800&seq=focus-wangluo-01&orientation=landscape",
    content: [
      "在社交平台上，一条内容的点赞数、转发量与粉丝规模，往往是判断其影响力的直观依据。而在这组数字背后，隐藏着一条规模不小的灰色产业链。",
      "## 三分钱一条的点赞",
      "通过暗访，记者接触到多个“数据服务”渠道。按其报价，单条点赞的价格可以低至几分钱，批量下单还能进一步压低成本。",
      "技术人员指出，这类服务通常依托大量自动化账号与设备集群实现，平台的风控机制在不断升级，对方也在不断绕过。",
      "## 数据造假伤害了谁",
      "有内容创作者表示，虚假数据会挤压真实创作者的曝光机会，也让广告投放的效果评估失真。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "wangluo-2",
    title: "AI换脸诈骗新套路：三分钟视频如何骗走养老钱",
    summary: "一段看似真实的视频通话，可能正是精心伪造的骗局。我们拆解了这类诈骗的常见环节。",
    categoryId: "wangluo",
    categoryName: "网络揭秘",
    publishedAt: "2026-10-11 19:25",
    source: "反诈前沿",
    tags: ["AI换脸", "诈骗", "防范"],
    heat: 9560,
    content: [
      "随着生成技术门槛降低，利用换脸与语音克隆实施的诈骗有所增多。受害者往往在接完一段视频通话后，匆忙完成了转账。",
      "## 诈骗的常见剧本",
      "梳理案例可以发现，此类诈骗常冒充亲友并制造紧急情境，例如“出事需要马上用钱”，以此压缩受害者的思考时间。",
      "反诈人员提醒，凡涉及转账的请求，都应通过其他独立渠道二次核实，切勿仅凭一段视频就相信对方身份。",
      "## 技术向善需要共同防线",
      "多位专家建议，平台应加强对合成内容的标识，公众也应提高对“眼见不一定为实”的认知。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "wangluo-3",
    title: "刷单炒信平台暗访：虚假好评如何批量制造",
    summary: "一条条好评可能是同一批人写出来的。我们记录了一次刷单任务的完整流程。",
    categoryId: "wangluo",
    categoryName: "网络揭秘",
    publishedAt: "2026-10-10 10:50",
    source: "消费观察室",
    tags: ["刷单", "虚假评价", "电商"],
    heat: 7020,
    content: [
      "消费者在电商平台挑选商品时，往往依赖评价。然而，部分好评并非来自真实体验，而是由刷单组织批量制造。",
      "## 一次刷单任务的流程",
      "在暗访中，记者加入了一个刷单群。任务发布后，参与者需按模板完成下单、截图与评价，组织者再返还本金并支付小额报酬。",
      "平台方表示，已通过行为识别与评价过滤打击刷单，但这类行为仍会变换形式出现。",
      "## 评价体系需要真实支撑",
      "有消费者表示，如果评价可以被批量制造，那么挑选商品的信心也会随之动摇。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "wangluo-4",
    title: "个人隐私数据买卖链条：你的手机号值多少钱",
    summary: "一条包含姓名与手机号的信息，在暗网市场上可能只值几毛钱。数据从哪里泄露？",
    categoryId: "wangluo",
    categoryName: "网络揭秘",
    publishedAt: "2026-10-09 13:35",
    source: "隐私研究组",
    tags: ["个人隐私", "数据泄露", "安全"],
    heat: 8120,
    content: [
      "在部分隐蔽的网络渠道中，包含姓名、手机号甚至收货地址的个人信息被明码标价。数据泄露的来源多种多样，普通用户往往并不知情。",
      "## 数据是怎么流出的",
      "安全研究人员介绍，泄露可能发生在注册、快递、营销等多个环节。一些企业内部的权限管理不严，会成为风险敞口。",
      "另有部分数据来自用户随手授权的第三方应用，在不知不觉中被汇集与转卖。",
      "## 减少泄露从习惯开始",
      "专家建议，用户应定期检查授权应用、谨慎提供个人信息，并注意不同平台设置差异化密码。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "wangluo-5",
    title: "网络水军公司运作揭秘：一条热搜是怎么被造出来的",
    summary: "从话题设定到集中发帖，一条热搜的形成可能经过周密策划。我们了解了其中的分工。",
    categoryId: "wangluo",
    categoryName: "网络揭秘",
    publishedAt: "2026-10-08 21:40",
    source: "舆论观察笔记",
    tags: ["网络水军", "热搜", "舆论"],
    heat: 7340,
    content: [
      "热搜榜位置常被视为话题热度的象征，但并非每一条热搜都完全来自自然讨论。部分话题的背后，存在有组织的推波助澜。",
      "## 水军的内部分工",
      "据知情者描述，这类团队通常设有策划、文案与执行等分工，通过批量账号在短时间内集中发布相似内容，制造热度的“假象”。",
      "平台方表示，正在持续打击异常传播行为，并对部分账号采取限制措施。",
      "## 理性看待热度",
      "传媒研究者提醒，公众在接收信息时应保持独立判断，避免被刻意制造的热度带偏。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "wangluo-6",
    title: "山寨App钓鱼事件：仿冒理财软件如何卷走用户存款",
    summary: "图标几乎一模一样，界面也高度还原。一款山寨软件，为何能骗过不少用户？",
    categoryId: "wangluo",
    categoryName: "网络揭秘",
    publishedAt: "2026-10-07 11:15",
    source: "金融反诈台",
    tags: ["山寨App", "钓鱼", "理财诈骗"],
    heat: 6480,
    content: [
      "近期，多起仿冒理财软件的诈骗案件被曝光。诈骗方通过短信、社交群等渠道引导用户下载安装，再以“高收益”诱导充值。",
      "## 仿真度是陷阱的关键",
      "安全分析显示，山寨软件在图标与界面上高度模仿正版应用，普通用户很难仅凭外观辨别真假。",
      "更隐蔽的是，这些软件往往通过非官方渠道分发，绕过了应用商店的审核。",
      "## 下载前多一步核实",
      "反诈人员提醒，涉及资金的软件务必通过官方渠道下载，并核实平台的资质信息，切勿点击来路不明的链接。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
];